__turbopack_context__.v({
  "countdownBox": "BirthdayTopBanner-module-scss-module__DAjWDG__countdownBox",
  "tierChip": "BirthdayTopBanner-module-scss-module__DAjWDG__tierChip",
});
